import React from 'react';
import type { CircleShape } from '../../types';
import { perimeterHitRects } from '../../utils/hitArea';

interface EllipseShapeProps {
  shape: CircleShape;
  isEditor?: boolean;
  isSelected?: boolean;
}

export const EllipseShape = React.memo(function EllipseShape({ shape, isEditor, isSelected }: EllipseShapeProps) {
  const x = shape.cx - shape.rx;
  const y = shape.cy - shape.ry;
  const w = shape.rx * 2;
  const h = shape.ry * 2;

  return (
    <g data-shape-id={shape.id}>
      {isEditor && (isSelected ? (
        <rect
          x={x - 0.015}
          y={y - 0.015}
          width={w + 0.03}
          height={h + 0.03}
          fill="transparent"
          stroke="none"
          pointerEvents="fill"
          style={{ cursor: 'inherit' }}
        />
      ) : (
        perimeterHitRects(x, y, w, h, 0.015).map((r, i) => (
          <rect
            key={i}
            x={r.x}
            y={r.y}
            width={r.width}
            height={r.height}
            fill="transparent"
            stroke="none"
            pointerEvents="fill"
            style={{ cursor: 'inherit' }}
          />
        ))
      ))}
      <ellipse
        cx={shape.cx}
        cy={shape.cy}
        rx={shape.rx}
        ry={shape.ry}
        fill="none"
        stroke={shape.color}
        strokeWidth={2}
        vectorEffect="non-scaling-stroke"
        pointerEvents="none"
      />
    </g>
  );
});
